// @charset "utf-8"
import Vue from 'vue'
import tipVue from '@/components/lib/tip'

// import { PopupManager } from 'element-ui/src/utils/popup'
// import { isVNode } from 'element-ui/src/utils/vdom',
var TipConstructor = Vue.extend(tipVue)

var instance
var instances = []
var seed = 1

var Tip = function (options) {
    if (Vue.prototype.$isServer) {
        return
    }
    options = options || {}
    if (typeof options === 'string') {
        options = {
            tip: options
        }
    }
    var userOnClose = options.onClose
    var id = 'tip_' + seed++

    options.onClose = function () {
        Tip.close(id, userOnClose)
    }
    instance = new TipConstructor({
        data: options
    })
    instance.id = id
    // if (isVNode(instance.tip)) {
    //   instance.$slots.default = [instance.tip]
    //   instance.tip = null
    // }
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    // instance.vm.top = 30 + instances.length * 8 + '%'
    instance.vm.top = 8 + instances.length * 8 + '%'
    instance.vm.right = 3 + '%'

    instance.vm.visible = true
    instance.dom = instance.vm.$el
    // instance.dom.style.zIndex = PopupManager.nextZIndex()
    instances.push(instance)
    return instance.vm
}

// var typeArr = ['success', 'warning', 'info', 'error']
// for (var i = 0; i <= 3; i++) {
//   Tip[typeArr[i]] = {
//     options : {
//       if (typeof options === 'string') {
//         options = {
//           tip: options
//         }
//       }
//       options.type = type
//       return Tip(options)
//     }
//   }
// }

Tip.close = function (id, userOnClose) {
    for (var i = 0, len = instances.length; i < len; i++) {
        if (id === instances[i].id) {
            if (typeof userOnClose === 'function') {
                userOnClose(instances[i])
            }
            instances.splice(i, 1)
            break
        }
    }
}

Tip.closeAll = function () {
    for (var i = instances.length - 1; i >= 0; i--) {
        instances[i].close()
    }
}

export default Tip



// WEBPACK FOOTER //
// ./src/lib/tipVue.js